import { ObjectsDrawer } from './ObjectsDrawer';
import { AspObject } from './AspObject';
import { DisplayObject } from './DisplayObject';
import { IMapMngr } from './interfaces';
import { AcousticVectorDataType, AcousticVectorDisplayObject } from './acousticVectorDisplayObject';
import { DisplayFilter, userSettings } from '../common/settings';

export class AcousticVectorDrawer extends ObjectsDrawer {
  constructor(mapMngr: IMapMngr, objectsPool, parentLayer) {
    super(mapMngr, objectsPool, DisplayFilter.AcousticVector, parentLayer, null, null, null, null);
    this.dataKeys.push(AcousticVectorDataType.AcousticVectorBack);
    this.dataKeys.push(AcousticVectorDataType.AcousticVector);
    this.dataKeys.push(AcousticVectorDataType.AcousticVectorText);
    this.dataKeys.push(AcousticVectorDataType.AcousticVectorHistory);
    this.typeKeys.push(AcousticVectorDataType.AcousticVectorBack);
    this.typeKeys.push(AcousticVectorDataType.AcousticVector);
    this.typeKeys.push(AcousticVectorDataType.AcousticVectorText);
    this.typeKeys.push(AcousticVectorDataType.AcousticVectorHistory);
  }

  protected addDrawTypes(images) {
    this.addFilledGeometryDrawType(AcousticVectorDataType.AcousticVectorBack, { properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha }, { properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha }, { enabled: true, selectable: true });
    this.addFilledGeometryDrawType(AcousticVectorDataType.AcousticVector, { properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha }, { properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha }, { enabled: true, selectable: true });
    this.addFilledGeometryDrawType(AcousticVectorDataType.AcousticVectorHistory, { properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha }, { properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha }, { enabled: true, selectable: true });
    this.drawMgr.addType(NeWMI.Draw.DrawMgr.Enums.EKinds.TextOrSymbol, AcousticVectorDataType.AcousticVectorText,
      {
        style: this.smallTextStyle,
        properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EORotation | NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha | NeWMI.Draw.DrawMgr.Enums.EProperties.EOSize,
      });
  }

  // ! tbd remove this thing and create something good instead...
  // Periodic refresh
  periodicUpdate(): boolean {
    if (!super.periodicUpdate())
      return false;

    if (this.drawMgr) {
      if (this.objectsLayerVisible) {
        if (this.drawMgr.typesVisualProps[AcousticVectorDataType.AcousticVectorBack]) {
          this.drawMgr.typesVisualProps[AcousticVectorDataType.AcousticVectorBack].visible = userSettings.acousticElementsOn[0];
        }
        if (this.drawMgr.typesVisualProps[AcousticVectorDataType.AcousticVector]) {
          this.drawMgr.typesVisualProps[AcousticVectorDataType.AcousticVector].visible = userSettings.acousticElementsOn[0];
        }
        if (this.drawMgr.typesVisualProps[AcousticVectorDataType.AcousticVectorText]) {
          this.drawMgr.typesVisualProps[AcousticVectorDataType.AcousticVectorText].visible = userSettings.acousticElementsOn[1];
        }
        if (this.drawMgr.typesVisualProps[AcousticVectorDataType.AcousticVectorHistory]) {
          this.drawMgr.typesVisualProps[AcousticVectorDataType.AcousticVectorHistory].visible = userSettings.acousticElementsOn[0];
        }
      }
    }

    return true;
  }

  createDisplayObject(obj: AspObject): DisplayObject {
    return new AcousticVectorDisplayObject(obj, this);
  }

  isLayerVisible(): boolean {
    return userSettings.filterOn[this.filterType];
  }

  onObjectDelete(obj: AspObject): void {
    // notified of ruler object deletion
    super.onObjectDelete(obj);
    this.mapMngr.redrawMap();
  }
}
